import '../../core/components/app-root/AppRoot.css';
import './PageLayout.css';
export var content = '_193kgwe3-3-12-1';
export var contentContainer = '_193kgwe2-3-12-1';
export var contentTopLeftRadius = '_193kgwe4-3-12-1';
export var contentTopRightRadius = '_193kgwe5-3-12-1';
export var headerContainer = '_193kgwe1-3-12-1';
export var layoutRoot = '_193kgwe0-3-12-1';